import { Input } from '@angular/core';
import { Component } from '@angular/core';

import { IThesisReport } from '../../models/ThesisReport';
import { AppService } from '../../services/app.service';
import { ThesisReportService } from '../../services/thesis-report.service';

import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-thesis-report-view',
    templateUrl: './view.component.html'
})
export class ThesisReportViewComponent {
    constructor(
        private app: AppService,
        private service: ThesisReportService
    ) { }

    @Input() report: IThesisReport;

    downloadAttachment(fileId: number, fileName: string) {
        this.app.addLoading(this.service.getAttachment(fileId)).subscribe(result => {
            FileSaver.saveAs(result, fileName);
        });
    }

    getSupervisorDisplay() {
        return this.report.Supervisors.map(t => t.Name).join(', ');
    }
}
